export function getProductName(name?: string, brand?: string, model?: string) {
  return name ? `${name} ( ${brand} - ${model} )` : `${brand} - ${model}`
}

export function getProductDetail(detail1?: string, detail2?: string, detail3?: string) {
  return [detail1, detail2, detail3].filter(Boolean).join(' - ') || '-'
}
